import { ApiResponse } from '@type/api'
import { axios } from '@utils/axios'
import getApiResponseData from '@utils/get-api-response-data'

import { log } from '../../../../config'

export async function fetchAppState() {
  try {
    log('fetchAppState Direct: /api/v1/userinfo')
    const { data } = await axios.get<ApiResponse<any>>('/userinfo', {
      validateStatus: () => true,
    })
    return getApiResponseData(data)
  } catch (e) {
    log('fetchAppState Direct Error: ', e)
  }
}

export async function fetchWbState() {
  try {
    log('fetchAppState Direct: /api/v1/billing/pricing/data')
    const { data } = await axios.get<ApiResponse<any>>('/billing/pricing/data', {
      validateStatus: () => true,
    })
    return getApiResponseData(data)
  } catch (e) {
    log('fetchAppState Direct Error: ', e)
  }
}
